import { gql } from '@apollo/client';

export const VALIDATE_CLOSE_OPERATION = gql`
    query ValidateCloseOperation($orderId: ID!, $closeType: String!) {
        validateCloseOperation(orderId: $orderId, closeType: $closeType) {
            isValid
            errorMessage
        }
    }
`;

export interface ValidateCloseOperationResponse {
    validateCloseOperation: {
        isValid: boolean;
        errorMessage?: string | null;
    };
}

